import { Box, TextField, Typography } from '@mui/material'
/**
 * The SerialNumberFilter component
 * @component
 *
 * @param {Object} props
 * @param {function} props.handleChangeNumSerie
 * @returns {JSX.Element}
 */

const SerialNumberFilter = ({ serialNumber, handleSerialNumber }) => {
  return (
    <Box
      sx={{
        width: '100%',
      }}
    >
      <Typography variant="body1">Serie</Typography>
      <TextField
        sx={{ mb: 1, width: '49.5%', minWidth: '49.5%' }}
        variant="standard"
        value={serialNumber}
        inputProps={{ maxLength: 3 }}
        onChange={(e) => {
          handleSerialNumber(e.target.value)
        }}
        type={'text'}
        placeholder="Serie"
        fullWidth
      />
    </Box>
  )
}

export default SerialNumberFilter
